import React from 'react';
import { StaticQuery, graphql } from 'gatsby';

const CopyrightContainer = ({ children, data }) => (
  <StaticQuery
		query={graphql`
		query SiteCopyrightQuery {
      site {
        siteMetadata{
					title
					rssMetadata {
						copyright
					}
        }
      }
    }
  `}
    render={data => (
			<React.Fragment>
				<p className="copyright-line">{data.site.siteMetadata.rssMetadata.copyright}</p>
      	{/* <p className="copyright-line">&copy; Copyright {data.site.siteMetadata.title}</p> */}
			</React.Fragment>
		)}
  />
);

const Footer = () => (
  <footer>
    <div className="container">

      <div className="up-footer">
        <div className="row">

          {/* <div className="col-md-4">
            <div className="footer-widget connect-widget">
              <h2>Connect with us</h2>
              <p>Get the latest updates.</p>
              <ul className="social-icons">
                <li><a className="facebook" href="#"><i className="fa fa-facebook"></i></a></li>
                <li><a className="twitter" href="#"><i className="fa fa-twitter"></i></a></li>
                <li><a className="linkedin" href="#"><i className="fa fa-linkedin"></i></a></li>
                <li><a className="instagram" href="#"><i className="fa fa-instagram"></i></a></li>
                <li><a className="youtube" href="#"><i className="fa fa-youtube"></i></a></li>
              </ul>
            </div>
          </div> */}

          {/* <div className="col-md-4">
            <div className="footer-widget subscribe-widget">
              <h2>Join the Newsletter</h2>
              <p>Creativity happens everywhere.</p>
              <form className="subscribe">
                <input type="text" name="enter-your-email" id="enter-your-email" placeholder="enter your email ..." />
                <input type="submit" name="subscribe-button" id="subscribe-button" value="Subscribe" />
              </form>
            </div>
          </div> */}

          {/* <div className="col-md-4">
            <div className="footer-widget text-widget">
              <h2>What is Business Conference</h2>
              <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis. Suspendisse urna nibh, viverra non, semper suscipit.</p>
            </div>
          </div> */}

        </div>
      </div>
      <CopyrightContainer />
    </div>
  </footer>
);

export default Footer;